/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AwsVaultConfig } from '../models/AwsVaultConfig';
import { AzureVaultConfig } from '../models/AzureVaultConfig';
import { GcpVaultConfig } from '../models/GcpVaultConfig';
import { Provider } from '../models/Provider';

/**
* Cloud-provider-specific vault attributes. 
*/
export class VaultProviderAttributes {
  'cloudProvider': Provider;
  'aws'?: AwsVaultConfig | null;
  'azure'?: AzureVaultConfig | null;
  'gcp'?: GcpVaultConfig | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "cloudProvider",
      "baseName": "cloudProvider",
      "type": "Provider",
      "format": ""
    },
    {
      "name": "aws",
      "baseName": "aws",
      "type": "AwsVaultConfig",
      "format": ""
    },
    {
      "name": "azure",
      "baseName": "azure",
      "type": "AzureVaultConfig",
      "format": ""
    },
    {
      "name": "gcp",
      "baseName": "gcp",
      "type": "GcpVaultConfig",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return VaultProviderAttributes.attributeTypeMap;
  }

  public constructor() {
  }
}



